export default {
  'home-stamp': () => import('@icons/home/home-stamp.svg'),
  'home-coupon': () => import('@icons/home/home-coupon.svg'),
};
